import { Component, HostBinding, Input, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';
import { BaseDirective } from '../../../base.directive';
import { coerceBooleanProperty } from '@angular/cdk/coercion';

@Component({
    selector: 'label[euiLabel], span[euiLabel], a[euiLabel], eui-label',
    template: '<ng-content></ng-content>',
    styleUrls: ['./styles/_index.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class EuiLabelComponent extends BaseDirective {
    @HostBinding('class')
    public get cssClasses(): any {
        return this.getCssClasses();
    }

    @Input()
    get euiRequired() {
        return this._required;
    }
    set euiRequired(required: any) {
        this._required = coerceBooleanProperty(required);
    }
    private _required: boolean;

    @Input()
    get euiReadonly() {
        return this._readonly;
    }
    set euiReadonly(readonly: any) {
        this._readonly = coerceBooleanProperty(readonly);
    }
    private _readonly: boolean;

    @Input() styleClass: string;

    constructor() {
        super();
    }

    getCssClasses() {
        return [
            super.getCssClasses('eui-label'),
            this._required ? 'eui-label--required' : '',
            this._readonly ? 'eui-label--readonly' : '',
        ].join(' ').trim();
    }
}
